// @flow

import * as React from 'react';
import Badge from 'sail/Badge';
import Group from 'sail/Group';
import Box from 'sail/Box';
import {Link} from 'docs/components';
import './CardGroupQuickLinks.scss';

export type CardGroupQuickLinksProps = {|
  links: Array<{|label: string, href: string|}>,
|};

export const CardGroupQuickLinks = ({links}: CardGroupQuickLinksProps) => (
  <Group
    direction="horizontal"
    style={{margin: '16px 0 0 -4px'}}
    wrap="wrap"
    className="CardGroup-quicklinks"
  >
    {links.map((item) => (
      <Box key={item.href} className="CardGroup-quicklinks-link">
        <Link href={item.href} title={item.label}>
          <Badge label={item.label} />
        </Link>
      </Box>
    ))}
  </Group>
);
